import React from "react";
import CommonRow from "../common-row";
const BigVideoStoryCard2Ad = props => {
  return <CommonRow {...props} />;
};

export default BigVideoStoryCard2Ad;
